async function updateFloatingCartCounter() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const counterEl = document.getElementById("CartCounterBubble");

    if (!counterEl) return;

    const count = cart.item_count;

    counterEl.textContent = count > 0 ? String(count) : "";
    counterEl.style.opacity = count > 0 ? 1 : 0;
  } catch (err) {
    console.error("Counter error:", err);
  }
}

function initPdpFloatingCartCounter() {
  updateFloatingCartCounter();
  setInterval(updateFloatingCartCounter, 2500);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdpFloatingCartCounter);
} else {
  initPdpFloatingCartCounter();
}

